import { Atin } from "../parsers/sthAtinParser";
import { BLANK_STH_TAXABILITY, STH_TAXABILITY_SEPARATOR } from "./constants";
import { isValidSthTaxability } from "../sth/sth";
import { ExcelValidationError } from "./ExcelValidationError";

export const parseSthTaxabilityPattern = (
  atin: Atin,
  row: Excel.Range,
  columnIndices: number[],
  sheetName?: string,
  rowNum?: number
) => {
  for (const column of columnIndices) {
    const sthTaxability = row.values[0][column].toString().trim();

    if (!isValidSthTaxability(sthTaxability)) {
      throw new ExcelValidationError(`Invalid STH taxability value "${sthTaxability}"`, sheetName, rowNum);
    }

    const sthTaxabilityCellValue = sthTaxability ? sthTaxability : BLANK_STH_TAXABILITY;
    if (!atin.secondaryTaxability) {
      atin.secondaryTaxability = sthTaxabilityCellValue;
    } else {
      atin.secondaryTaxability += STH_TAXABILITY_SEPARATOR + sthTaxabilityCellValue;
    }
  }
};
